require('./tppKeyDetailsInfo.scss');
import { ContentBox } from 'commonsComponents/contentBox';
const PropTypes = require('prop-types');
const React = require('react');

// @ constants
const {
    TPP_KEY_TYPE_AISP
} = require('constants/tpps');

//@helpers
const { FormattedText } = require('core/i18n').i18n;
const {getTppTypeKey} = require('utilities/tpps/tppKeysHelper');
const { filterAccountsInfo } = require('utilities/tpps/tppKeysHelper');
const { getLastNChars } = require('utilities/stringHelper');

class TppKeyDetailsInfo extends React.Component {
    buildConsentRows(selectedAccounts) {
        return selectedAccounts.map(accounts => {
            return accounts.map(account => {
                const accountKey = account.get('accountId');
                const accountName = account.get('alias');
                const actualCgdNumber = account.get('contractNumber');
                const shortCgdNumber = getLastNChars(actualCgdNumber, 4, '.');
                return (
                    <div key={accountKey} className="tpp-key-detail-info__consent-row">
                        <div className="tpp-key-detail-info__consent-value">{accountName}</div>
                        <div className="tpp-key-detail-info__consent-value">{shortCgdNumber}</div>
                    </div>
                );
            })
        })
    }

    buildAggregator = () => {
        const { immAccounts, immTpp } = this.props;
        const associatedAccounts = immTpp.getIn(['consents', TPP_KEY_TYPE_AISP, 'accounts']);
        const hasReadableConsent = immTpp.get('hasReadableConsent');
        const consentRows = hasReadableConsent ? this.buildConsentRows(associatedAccounts.map(account => immAccounts.filter(a => a.get('iban') === account))) : <FormattedText value="keysTppView-No"/>;
        return (
            <div className="tpp-key-detail-info__content-item">
                <div className="tpp-key-detail-info__content-label">
                    <FormattedText value="keysTppView-readConsentTPP"/>
                </div>
                <div className="tpp-key-detail-info__content-value">{consentRows}</div>
            </div>
        )
    }

    buildPaymentGateway = () => {
        const {immTpp } = this.props;
        const hasFundsConsent = immTpp.get('hasFundsConsent');
        const value = <FormattedText value={`keysTppView-${hasFundsConsent && 'Yes' || 'No'}`}/>;
        return (
            <div className="tpp-key-detail-info__content-item">
                <div className="tpp-key-detail-info__content-label">
                    <FormattedText value="keysTppView-foundConsents"/>
                </div>
                <div className="tpp-key-detail-info__content-value">
                    {value}
                </div>
            </div>
        )
    }

    buildTypeTPPInfo = () => {
        const { immTpp } = this.props;
        const tppTypeText = getTppTypeKey(immTpp)

        return (
            <div className="tpp-key-detail-info__content-item">
                <div className="tpp-key-detail-info__content-label">
                    <FormattedText value="keysTppView-typeTPP" />
                </div>
                {tppTypeText && <FormattedText value={tppTypeText}/>}
            </div>
        )
    }

    renderProductList = (productList) => {
        const { immAccounts } = this.props;
        const productListId = productList.get('items').map(product => product.get("id"))
        const filteredAccountsInfo = filterAccountsInfo({immAccounts, productListId});

        return filteredAccountsInfo.map(account => {
            const shortCgdNumber = getLastNChars(account.iban, 4, '.');
            return (
                <div key={account.iban} className="tpp-key-detail-info__consent-row">
                    <div className="tpp-key-detail-info__consent-value">{account.alias}</div>
                    <div className="tpp-key-detail-info__consent-value">{shortCgdNumber}</div>
                </div>
            );
        })
    }

    renderProducts = (products) => {
        if(!products || products.size === 0) return '-';
        return products.map(product => {
            return this.renderProductList(product);
        })
    }

    render() {
        const { consentState, consentRecurringIndicator, products } = this.props;
        return (
            <div>
                <ContentBox>
                    <div className="tpp-key-detail-info__title">
                        <FormattedText value="keysTppView-activeConsent" />
                    </div>
                    <div className="tpp-key-detail-info__separator"></div>
                    <div className="tpp-key-detail-info__content">
                        <div className="row">
                            <div className="col-xs-12 col-md-6">
                                <div className="tpp-key-detail-info__content-item">
                                    <div className="tpp-key-detail-info__content-label"> 
                                        <FormattedText value="keysTppView-consentStatusTitle" />  
                                    </div>
                                    <div className="tpp-key-detail-info__content-value"> {consentState} </div>
                                </div>
                                <div className="tpp-key-detail-info__content-item">
                                    <div className="tpp-key-detail-info__content-label"> 
                                        <FormattedText value="keysTppView-consentTypeTitle"/>  
                                    </div>
                                    <div className="tpp-key-detail-info__content-value"> {consentRecurringIndicator} </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6">

                                <div className="tpp-key-detail-info__content-item">
                                    <div className="tpp-key-detail-info__content-label"> 
                                        <FormattedText value="keysTppView-consentProductsTitle" /> 
                                    </div>
                                    <div className="tpp-key-detail-info__content-value"> {this.renderProducts(products)} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ContentBox>
            </div>
        );
    }
}

TppKeyDetailsInfo.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immTpp: PropTypes.object.isRequired,
    resetTppKey: PropTypes.func.isRequired,
    consentState: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
      ]).isRequired,
    consentRecurringIndicator: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
      ]).isRequired,
    products: PropTypes.object,
};

module.exports = TppKeyDetailsInfo;